import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { getNoticeList, getNoticeTotals, addNotice, editNotice, deleteNotice, changeStatusNotice, noticeViewReport} from "../../helpers/api";
import { GET_NOTICE_LIST, GET_NOTICE_TOTALS, ADD_NOTICE, EDIT_NOTICE, DELETE_NOTICE, CHANGE_STATUS_NOTICE, NOTICE_VIEW_REPORT } from "./actionTypes";
import { getNoticeListResponce, getNoticeTotalsResponce, getNoticeViewReportResponce} from "./actions";

//Include Both Helper File with needed methods
import { showToast } from "../toast/actions";




/**
 * Generator function that retrieves a list of depots using the provided token.
 * @param {Object} payload - The payload object containing the token.
 * @param {string} payload.token - The authorization token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* noticeList({ payload: { data }, success, failure}){

  try {
    const responce = yield call(getNoticeList, data)
    // Only update Redux state if we have actual data (not empty/204 response)
    // Check if response has data array with items, or if response structure indicates real data
    const hasData = responce && (
      (Array.isArray(responce?.data?.data) && responce.data.data.length > 0) ||
      (Array.isArray(responce?.data) && responce.data.length > 0) ||
      (responce?.data && typeof responce.data === 'object' && Object.keys(responce.data).length > 0)
    );
    
    if (hasData) {
      yield put(getNoticeListResponce(responce));
      success(responce)
    } else {
      // Empty/204 response - don't update state, but still call success callback
      // The component will handle keeping the loader running
      success(responce)
    }
    
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }
}

/**
 * Generator function that adds a notice to the system.
 * @param {Object} payload - The payload object containing the notice data.
 * @param {Object} payload.data - The data of the notice to be added.
 * @param {Function} success - The success callback function.
 * @param {Function} failure - The failure callback function.
 * @returns None
 */
function* noticeAdd({ payload: {data}, success, failure}){
  try {
    const responce = yield call(addNotice, data);
    if (responce) {
      yield put(showToast({
        message: responce?.message,
        type: "success"
      }));
      success(responce)
      
    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that handles editing notices.
 * @param {object} payload - The payload object containing the notice ID and data to edit.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* editNotices({ payload: { id, data }, success, failure}){

  try {
    const response = yield call(editNotice, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that deletes a notice based on the provided ID.
 * @param {object} payload - The payload object containing the ID of the notice to delete.
 * @param {function} success - The success callback function to be called after the notice is deleted.
 * @param {function} failure - The failure callback function to be called if an error occurs during deletion.
 * @returns None
 */
function* deleteNotices({ payload: { id }, success, failure}){

  try {
    const response = yield call(deleteNotice, id);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that changes the status of a notice.
 * @param {object} payload - The payload object containing the notice ID and data.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* changeNoticeStatus({ payload: { id, data }, success, failure}){

  try {
    const response = yield call(changeStatusNotice, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}


/**
 * Generator function that handles fetching notice view reports and dispatching actions based on the result.
 * @param {Object} options - The options object.
 * @param {Function} options.success - The success callback function.
 * @param {Function} options.failure - The failure callback function.
 * @returns None
 */
function* noticeViewRepots({ payload: { id, data }, success, failure}){

  try {
    const responce = yield call(noticeViewReport, id, data)
    if (responce){
      yield put(getNoticeViewReportResponce(responce));
      success(responce)
    }
    
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }
}



/**
 * Generator function that retrieves notice totals.
 * @param {Object} payload - The payload object containing query data.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* noticeTotals({ payload: { data }, success, failure}){
  try {
    const responce = yield call(getNoticeTotals, data)
    if (responce) {
      yield put(getNoticeTotalsResponce(responce));
      success(responce)
    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
  }
}

function* noticeManagement() {
     yield takeEvery(GET_NOTICE_LIST, noticeList);
     yield takeEvery(GET_NOTICE_TOTALS, noticeTotals);
     yield takeEvery(ADD_NOTICE, noticeAdd);
     yield takeEvery(EDIT_NOTICE, editNotices);
     yield takeEvery(DELETE_NOTICE, deleteNotices);
     yield takeEvery(CHANGE_STATUS_NOTICE, changeNoticeStatus);
     yield takeEvery(NOTICE_VIEW_REPORT, noticeViewRepots);
     yield takeEvery('GET_NOTICE_REPORT_DATA', getNoticeReportDataSaga);
}

function* getNoticeReportDataSaga(action) {
  try {
    const { id, data } = action.payload;
    // Use the imported getNoticeReportData function instead of api.post directly
    const response = yield call(noticeViewReport, id, data);

    // Don't dispatch to store for export data
    // Just call success callback with response data
    if (action.success) {
      yield call(action.success, response.data);
    }
  } catch (error) {
    if (action.failure) {
      yield call(action.failure, error);
    }
  }
}

export default noticeManagement;
